module.exports = "/packs/images/svg/facilities/football_pitch~c6928fb35bfec8a5ae87ce7d7c3ababc.svg";